import { Link } from "react-router";

import { type FileRecord } from "@/shared/domain/files";
import { useFile } from "@/shared/domain/files/hooks/useFile";
import { linkTarget } from "@/shared/domain/files/linkTarget";
import { Goto } from "@/shared/navigation";

import styles from "./LinkTargetLabel.module.css";

interface LinkTargetLabelProps {
  /** A file record whose `fs_type` is `link`. */
  link: FileRecord;
}

/**
 * Names the file a link points to, as a link to that file's page. Shows the
 * target's path, or its file ID while the target's record loads or if it fails
 * to load, followed by the version the link pins, when it pins one.
 */
export function LinkTargetLabel({ link }: LinkTargetLabelProps) {
  const { fileId, version } = linkTarget(link);
  const { data: target } = useFile(fileId);

  return (
    <span className={styles.target}>
      <span aria-hidden>{"→ "}</span>
      <Link className={styles.path} to={`${Goto.route.Files}/${fileId}`}>
        {target?.relative_path ?? fileId}
      </Link>
      {version !== undefined && ` (v${version})`}
    </span>
  );
}
